var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF8E5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 36H22.75C21.3576 36 20.0223 35.4469 19.0377 34.4623C18.0531 33.4777 17.5 32.1424 17.5 30.75C17.5 29.3576 18.0531 28.0223 19.0377 27.0377C20.0223 26.0531 21.3576 25.5 22.75 25.5C23.1892 25.4998 23.6269 25.5534 24.0531 25.6594",
    stroke: "#FCFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28.5C23.5 27.3116 23.7824 26.1402 24.3239 25.0824C24.8655 24.0246 25.6506 23.1105 26.6147 22.4157C27.5787 21.7208 28.6941 21.265 29.8689 21.0858C31.0437 20.9066 32.2443 21.0091 33.3717 21.3849C34.4991 21.7607 35.5211 22.399 36.3534 23.2473C37.1857 24.0955 37.8045 25.1294 38.1589 26.2637C38.5132 27.3981 38.5929 28.6004 38.3914 29.7716C38.1899 30.9427 37.713 32.0493 37 33",
    stroke: "#FCFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.072 31.6781L30.2501 28.5L33.4283 31.6781",
    stroke: "#FCFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 36V28.5",
    stroke: "#FCFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.411b256325bdb955f8a7f2f526e36c71.svg";
export { ForwardRef as ReactComponent };